import { configureStore } from "@reduxjs/toolkit";

//* import reducer ( Slices files )
import authReducer from "./Slices/auth";
import headerReducer from "./Slices/header";
import globalDialogsReducer from "./Slices/globalDialogs";
import loaderReducer from "./Slices/loader";
const store = configureStore({
  reducer: {
    auth: authReducer,
    header: headerReducer,
    globalDialogs: globalDialogsReducer,
    loader: loaderReducer,
  },
  // devTools: true
});

export default store;
